    <template>
      <fragment>
        <div class="row location-search-block__search floating-label">
          <div class="col-12">
            <span class="pill large">
              <label class="location-search-block__label">{{ placeholdertext }}</label>
              <gmap-autocomplete ref="place" type="search" :select-first-on-enter="true" @place_changed="setPlace"
                aria-label="Search" placeholder="" aria-describedby="search-by-location-autocomplete"
                @blur="toggleLabel($event)" @focus="toggleLabel($event)"
                :options="{ bounds: { north: 39.5, south: 27.3, east: -83.52, west: -98.88 }, strictBounds: true }" />
              <button v-on:click="setPlaceBySubmit" class="location-search-block__filters-search"><img
                  src="/Static/assets/images/search_icon_red.svg" alt="search" /></button></span>
            <p class="sr-only" id="search-by-location-autocomplete">Begin typing to search, the field will be completed as you type. Use arrow keys to navigate, Enter to select.</p>
          </div>
        </div>
      </fragment>
    </template>

<script>

import axios from "axios";
import * as VueGoogleMaps from "vue2-google-maps";
import Vue from "vue";
import { mapActions } from "vuex";
import VueMq from "vue-mq";
import { googleApi } from "../../../config/map";
import { gmapApi } from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: googleApi.geoKey,
    v: "3.40"
  },
  installComponents: false
});
Vue.use(VueMq, {
  breakpoints: {
    mobile: 678,
    tablet: 992,
    desktop: Infinity
  }
});

export default {
  data() {
    return {
      advisorData: null,
      errored: false,
      noadvisors: false,
      locationSearch: null,
      index: 0,
      focused: false,
      errored: false,
      loading: false,
      showDefault: false,
      loaded: false,
      radius: 20,

      hideform: false
    }
  },
  components: {
    "gmap-autocomplete": VueGoogleMaps.Autocomplete
  },
  mounted() {
    var self = this;
    this.getSearchFromLocalStore(self)
  },
  computed: {
    isMobile() {
      return this.$mq != 'desktop';
    },

    google: gmapApi
  },
  methods: {
    ...mapActions([
      "geolocateUser"
    ]),
    setPlace(place) {
      // Convert address to lat and lng and save.
      this.searchTerm = place.formatted_address;

      if (place.geometry) {
        const payload = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
          radius: "20",
          term: this.searchTerm
        }

        window.localStorage.setItem('userSearch', true);
        window.localStorage.setItem("userPayload", JSON.stringify(payload));
        window.location = "/locations"
        //EventBus.scrollToTop();
      }
    },
    setPlaceBySubmit() {
      const el = this.$refs.place.$refs.input;
      if(el.value !== '') {
        window.location = "/locations"
      }
      
      // const ev = new Event('keydown');

      // ev.which = 13;
      // ev.keyCode = 13;

      // console.log(el, ev)
      // return el.dispatchEvent(ev);
    },
    getSearchFromLocalStore(self) {

      var isUserSearch = window.localStorage.getItem('userSearch');
      if (isUserSearch === null || isUserSearch === 'false') {
        return;
      }

      var payloadString = window.localStorage.getItem("userPayload");
      if (payloadString !== null) {
        var payload = JSON.parse(payloadString);

        if (payload.term !== undefined) {
          self.$refs.place.$el.value = payload.term;

          const searchEl = document.getElementsByClassName("location-search-block__search");
          if (searchEl) {
            searchEl[0].classList.add('is-floating');
          }
        }
      }
    },
    toggleLabel(event) {
      const parent = document.querySelector('.location-search-block__search')
      if (event.type === 'focus') {
        // For IE support, keep the following add() methods separate
        parent.classList.add('has-focus')
        parent.classList.add('is-floating')
      }
      if (event.type === 'blur') {
        parent.classList.remove('has-focus')
        if (event.target.value === '') {
          parent.classList.remove('is-floating')
          //reset to user's location
          this.geolocateUser();
        }
      }
    },

    async allowLocation() {
      if (navigator.userAgent.indexOf("iPhone") != -1) {
        navigator.geolocation.getCurrentPosition(
          position => {
            // if it is iPhone and user hits accept I use the Browser lat and long
            this.getAdvisors(position.coords.latitude, position.coords.longitude, this.advisortypecategory)
          },
          error => {
            console.log(error.message)
            // if not, I use the existing lat and long
            this.getAdvisors(this.latitude, this.longitude, this.advisortypecategory)
          }
        )
      } else {
        let advisorsBlockDefault = document.getElementById('featured-advisors')
        advisorsBlockDefault.classList.add('default-advisors-active')
        this.showDefault = true
      }
    },
    getPersonalizationData() {
      var self = this;
      var cached_userZip = window.localStorage.getItem('userZip');
      if (cached_userZip) {
        this.zipdata = cached_userZip;
        this.longdata = window.localStorage.getItem('longData');
        this.latdata = window.localStorage.getItem('latData');
        this.getInitialAdvisors()
      }
      else {
        if (window.localStorage.getItem('stopPersonalization') != "true") {
          var ipaddressTest = HERO_getQueryStringParam("ipaddress");
          var passData = "";
          if (HERO_getQueryStringParam("ipaddress") != "") {
            passData = "?ipaddress=" + ipaddressTest
          }

          $.ajax({
            type: 'GET',
            url: '/api/personalization' + passData,
            contentType: 'application/json; charset=utf-8',
            success: function (data) {

              if (data.geoLocationState == null && data.ipAddress == null &&
                data.geoLocationPostalZip == null && data.geoLongitude == null && data.geoLatitude == null) {
                window.localStorage.setItem('stopPersonalization', "true");
              }
              else if (data.geoLocationPostalZip != null && data.geoLongitude != null && data.geoLatitude != null) {
                if (data.geoLocationPostalZip != null) {
                  self.zipdata = data.geoLocationPostalZip;
                  window.localStorage.setItem('userZip', data.geoLocationPostalZip);
                }
                if (data.geoLongitude != null) {
                  self.longdata = data.geoLongitude;
                  window.localStorage.setItem('longData', data.geoLongitude);
                }
                if (data.geoLatitude != null) {
                  self.latdata = data.geoLatitude;
                  window.localStorage.setItem('latData', data.geoLatitude);
                }
                if (data.geoLocationState != null) {
                  window.localStorage.setItem('geoState', data.geoLocationState);
                }
                if (data.ipAddress != null) {
                  window.localStorage.setItem('ipAddress', data.ipAddress);
                }
                setTimeout(function () {
                  self.getInitialAdvisors()
                }, 400);
              }
              else {
                self.getInitialAdvisors()
              }
            },
            error: function () {
              self.getInitialAdvisors()
            }
          })
        }
      }
    }
  },
  props: {
    placeholdertext: String
  },
  watch: {
  }
}
</script>
